import React from "react";

export default function Icon({ name, className = "" }) {
  return (
    <svg className={"icon icon-" + name + (className ? " " + className : "")}>
      <use xlinkHref={"#icon-" + name} />
    </svg>
  );
}
